import $ from 'jquery';

export default function initFloatingCTA() {
    $(function() {
        let $button = $('.floating-cta');
        if($button.length > 0 && $('.modules section:last-child').hasClass('module-m4')) {
            function positionFloatingCTA() {
                // Need to show and hide the button in order to get its correct offset. It will then be shown if it needs to be
                $button.show();
                let m4top = $('.modules section:last-child').offset().top;
                let secondChild = $(".modules").children().eq(1).offset().top + $(".modules").children().eq(1).height()
                let ctaBottom = $button.offset().top + $button.height();
                $button.hide();
                if(ctaBottom >= m4top || ctaBottom <= secondChild) {
                    $button.hide();
                } else {
                    $button.show();
                }
            }

            positionFloatingCTA();
            $(window).on('scroll', function(e) {
                positionFloatingCTA();
            });

        }
    });
}